import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["hours", "startTime", "endTime", "timeDisplay"];
  // Not used anymore. Replaced by our customDateFormat. Kept for reference to Datepicker.coffee
  //static formatString = '%Y-%m-%d %H:%M'; // Used to update the datepicker, and duplicated in Datepicker.coffee
  static initialStartTime;

  // This controller needs to hande 3 possible states:
  // Completely new time report - start and end time will be blank, we don't need to do anything since hours will be set to 0 by updateHours, and the start and end time fields should just be left blank
  // Active time report - start time will be set, end time field won't exist at all, and hours should be set based on on start time only, which is handled by getEndTime returning the current time if there is no field
  // Existing time report - start time and end time will be set, hours should be updated

  connect() {
    this.updateHours();
    this.updateStartAndEndTimeFromHours();
    this.updateTimeDisplay();
  }

  getStartTime() { return Date.parse(this.startTimeTarget.value); }
  getEndTime() { return (this.hasEndTimeTarget) ? Date.parse(this.endTimeTarget.value) : new Date(); }

  parseHours() { return parseFloat(this.hoursTarget.value.replace(',', '.')) || 0; }
  parseMinutes() { return this.parseHours() * 60; }
  padTimeBasedStrings(number) { number = new String(number); return (number.length < 2 ? '0' + number : number); }

  arrowUp(event) { return event.keyCode == '38'; }
  arrowDown(event) { return event.keyCode == '40'; }

  setEndTimeTargetToCurrentTimeIfExistsAndIsEmpty() {
    // This only happens on new time reports (from time report tab) when the user enters a value into the hours field
    // It's possible to start a time report without start / end time, which will create a new "active" time report,
    // meaning it is "running" and tracking time. It will be given a start time, but no end time by the backend.
    if(this.hasEndTimeTarget && this.endTimeTarget.value == "") {
      this.endTimeTarget.value = this.customDateFormat(new Date());
    }
  }

  hoursKeyUp(event) {
    this.setEndTimeTargetToCurrentTimeIfExistsAndIsEmpty();
    if (this.arrowUp(event) || this.arrowDown(event)) {
      var hours = this.parseHours() || 0;

      // We round to nearest 15min first so arrows can be used as rounding feature also
      // We want 1.1 to turn into 1.25 if up is pressed, and 1.0 if down is pressed.
      // See older version of this file for a version without rounding.
      var quarterChunks = Math.floor(hours / 0.25);
      var dir = 1; // We assume arrow up until proven otherwise

      if (this.arrowDown(event)) { // Nope, it was down
        // To get expected behaviour (1.1 -> 1.0 if down is pressed), we have to add 0.25 if
        // hours isn't evenly divisible by 0.25
        if (hours % 0.25 != 0) { quarterChunks += 1; }
        dir = -1;
      }

      hours = 0.25 * quarterChunks + (0.25 * dir);

      // Prevent negative
      if (hours >= 0) { this.hoursTarget.value = hours; }
    }

    this.updateStartAndEndTimeFromHours();
    this.updateTimeDisplay();
  }

  customDateFormat(date) {
    let str = date.toLocaleString('sv-SE'); // Easiest way to get rid of AM/PM when language is english
    return str.slice(0, -3); // Remove seconds ':00'
  }

  updateStartAndEndTimeFromHours() {
    var minutes = this.parseMinutes() || 0;
    var endTime = this.getEndTime();

    // If we have no endTime at this point, it's because the user wants to start a new active time report from 
    // the time reports tab. In that case, we don't want to update anything.
    if (!endTime) { return; }

    // The startTime is always set based on the endTime (which, in the case of an active time report, will be set
    // to the current time) and the hours field.
    var startTime = new Date(endTime.getTime()); // Just a (hopefully) browser safe way to copy a datetime
    startTime.setMinutes(startTime.getMinutes() - minutes);
    this.startTimeTarget.value = this.customDateFormat(startTime);

    // Refresh the datepicker. See DatePicker.coffee.
    event = document.createEvent('event');
    event.initEvent('request-calendar-update', false, false);
    this.startTimeTarget.dispatchEvent(event);
    if (this.hasEndTimeTarget) { // When this form is used from the todos tab, there is no end time field
      this.endTimeTarget.dispatchEvent(event);
    }
  }

  updateHours() {
    // On a new time report, these fields will both be blank, which will result in both these
    // values being null. Fortunately for us, null - null is 0, which is what we want in that case.
    // This method is called once on init, and then whenever the datetime fields are manually changed.
    const diffInMilliseconds = this.getEndTime() - this.getStartTime();
    const diffInHours = diffInMilliseconds / 3600000;
    this.hoursTarget.value = diffInHours.toFixed(2);
    this.updateTimeDisplay();
  }

  updateTimeDisplay() {
    const hoursString = this.padTimeBasedStrings(Math.floor(this.parseMinutes() / 60));
    const minutesString = this.padTimeBasedStrings(Math.round((this.parseMinutes() % 60)));
    this.timeDisplayTarget.innerHTML = `${hoursString}h ${minutesString}m`;
  }
}